<div [ngClass]="{ preview: preview }">
  <div *ngIf="title" class="title px">
    {{ title }}
  </div>
  <ng-container *ngFor="let muscleGroup of muscleGroups">
    <ion-chip
      *ngIf="!preview || toggleStates.get(muscleGroup.group)"
      [class.chip-active]="toggleStates.get(muscleGroup.group)"
      [ngStyle]="
        toggleStates.get(muscleGroup.group)
          ? { background: muscleGroup.color }
          : {}
      "
      [style.border-color]="muscleGroup.color"
      [outline]="true"
      (click)="toggleChipGroup(muscleGroup)"
    >
      {{ muscleGroup.group }}
    </ion-chip>
    <ng-container *ngIf="toggleStates.get(muscleGroup.group)">
      <ng-container *ngFor="let muscle of muscleGroup.muscles">
        <ion-chip
          *ngIf="!preview || toggleStates.get(muscle)"
          [class.chip-active]="toggleStates.get(muscle)"
          [outline]="true"
          (click)="toggleChip(muscle)"
          [ngStyle]="
            toggleStates.get(muscle) ? { background: muscleGroup.color } : {}
          "
          [style.border-color]="muscleGroup.color"
        >
          {{ muscle }}
        </ion-chip>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
